var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { style: _vm.color ? "color: " + _vm.color + ";" : "" },
    [
      _vm.editMode
        ? [
            _c(
              "v-layout",
              { attrs: { "justify-space-between": "" } },
              [
                _c(
                  "v-flex",
                  { attrs: { sm4: "" } },
                  [
                    _c("v-text-field", {
                      staticClass: "required_field",
                      attrs: {
                        id: "receipient_name",
                        label: _vm.$t("recipientName"),
                        rules: [_vm.fieldIsRequired("receipient name")]
                      },
                      on: { keyup: _vm.onChange },
                      model: {
                        value: _vm.localValue.accountHolder,
                        callback: function($$v) {
                          _vm.$set(_vm.localValue, "accountHolder", $$v)
                        },
                        expression: "localValue.accountHolder"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-flex",
                  { attrs: { sm4: "" } },
                  [
                    _c("v-text-field", {
                      staticClass: "required_field",
                      attrs: {
                        id: "phone_number",
                        label: _vm.$t("phoneNumber"),
                        rules: [_vm.fieldIsRequired("phone number")]
                      },
                      on: { keyup: _vm.onChange },
                      model: {
                        value: _vm.localValue.phoneNumber,
                        callback: function($$v) {
                          _vm.$set(_vm.localValue, "phoneNumber", $$v)
                        },
                        expression: "localValue.phoneNumber"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "v-layout",
              [
                _c("v-text-field", {
                  staticClass: "required_field",
                  attrs: {
                    id: "receipient_address",
                    label: _vm.$t("recipientAddress"),
                    rules: [_vm.fieldIsRequired("Receipient address")]
                  },
                  on: { keyup: _vm.onChange },
                  model: {
                    value: _vm.localValue.address,
                    callback: function($$v) {
                      _vm.$set(_vm.localValue, "address", $$v)
                    },
                    expression: "localValue.address"
                  }
                })
              ],
              1
            )
          ]
        : [
            _vm.fullDetail
              ? _c(
                  "v-layout",
                  { attrs: { column: "" } },
                  [
                    _c(
                      "v-layout",
                      [
                        _c(
                          "v-flex",
                          { attrs: { sm6: "", md4: "" } },
                          [
                            _c(
                              "v-layout",
                              [
                                _c("v-flex", { attrs: { sm6: "" } }, [
                                  _vm._v(_vm._s(_vm.$t("recipientName")) + ":")
                                ]),
                                _c("v-flex", { attrs: { sm6: "" } }, [
                                  _vm._v(_vm._s(_vm.localValue.accountHolder))
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-layout",
                      [
                        _c(
                          "v-flex",
                          { attrs: { sm6: "", md4: "" } },
                          [
                            _c(
                              "v-layout",
                              [
                                _c("v-flex", { attrs: { sm6: "" } }, [
                                  _vm._v(_vm._s(_vm.$t("phoneNumber")) + ":")
                                ]),
                                _c("v-flex", { attrs: { sm6: "" } }, [
                                  _vm._v(_vm._s(_vm.localValue.phoneNumber))
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-layout",
                      [
                        _c(
                          "v-flex",
                          { attrs: { sm6: "", md4: "" } },
                          [
                            _c(
                              "v-layout",
                              [
                                _c("v-flex", { attrs: { sm6: "" } }, [
                                  _vm._v(
                                    _vm._s(_vm.$t("recipientAddress")) + ":"
                                  )
                                ]),
                                _c("v-flex", { attrs: { sm6: "" } }, [
                                  _vm._v(_vm._s(_vm.localValue.address))
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              : _c(
                  "v-layout",
                  { attrs: { column: "" } },
                  [
                    _c("v-flex", [
                      _vm._v(
                        _vm._s(_vm.localValue.accountHolder) +
                          " * " +
                          _vm._s(_vm.localValue.address) +
                          " * " +
                          _vm._s(
                            _vm.localValue.phoneNumber &&
                              _vm.formatPhoneNumber(_vm.localValue.phoneNumber)
                          )
                      )
                    ])
                  ],
                  1
                )
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5e9f2ab6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e9f2ab6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PaymentCheckWidget.vue
// module id = null
// module chunks = 